import {IConfigMaker} from '../../@interfaces/services/ConfigMaker/IConfigMaker';
import {IFormConfig} from '../../@interfaces/components/Form/IFormConfig';
import {IListConfig} from '../../@interfaces/components/List/IListConfig';
import {IInteractiveListConfig} from '../../@interfaces/services/ConfigMaker/IInteractiveListConfig';
import {IInteractiveFormConfig} from '../../@interfaces/services/ConfigMaker/IInteractiveFormConfig';
import Cacheable from '../../classes/Cacheable/Cacheable';
import ListConfig from './ListConfig';
import FormConfig from './FormConfig';
import {IModelFormConfig} from '../../@interfaces/components/Form/IModelFormConfig';

type TCache = IInteractiveListConfig | IInteractiveFormConfig;

export default class ConfigMaker extends Cacheable<TCache> implements IConfigMaker {
    makeListConfig(controllerName: string, configAttributes: IListConfig): IInteractiveListConfig {
        return this.remember<IInteractiveListConfig>(
            this.getListConfigCacheKey(controllerName, configAttributes),
            () => new ListConfig({...configAttributes, controllerName})
        );
    }

    forgetListConfigCache(controllerName: string, configAttributes: IListConfig) {
        this.forgetRemember(
            this.getListConfigCacheKey(controllerName, configAttributes)
        );
    }

    makeFormConfig(
        controllerName: string,
        configAttributes: IModelFormConfig,
        urlParams: { id?: string }
    ): IInteractiveFormConfig {
        return this.remember<IInteractiveFormConfig>(
            this.getFormConfigCacheKey(controllerName, configAttributes, urlParams),
            () => new FormConfig({...configAttributes, controllerName, urlParams})
        );
    }

    forgetFormConfigCache(controllerName: string, configAttributes: IModelFormConfig, urlParams: { id?: string }) {
        this.forgetRemember(
            this.getFormConfigCacheKey(controllerName, configAttributes, urlParams),
        );
    }

    protected getListConfigCacheKey(controllerName: string, config: IListConfig): string {
        return this.stringify(config) + '|' + controllerName;
    }

    protected getFormConfigCacheKey(controllerName: string, config: IFormConfig, urlParams: Record<string, any>): string {
        return this.stringify({...config, controllerName, urlParams});
    }
}
